import { useState, MouseEvent, useCallback } from 'react';

export type HandleShowMenu = (event: MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
export type HandleCloseMenu = () => void;
export type AnchorMenuEl = HTMLButtonElement | HTMLDivElement | null;
export type ShowMenu = boolean;

export const useMenuState = () => {
  const [anchorEl, setAnchorEl] = useState<AnchorMenuEl>(null);

  const handleShowMenu: HandleShowMenu = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, [setAnchorEl]);

  const handleCloseMenu: HandleCloseMenu = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const showMenu: ShowMenu = Boolean(anchorEl);

  return { showMenu, anchorEl, handleShowMenu, handleCloseMenu } as const;
};
